import { type IconProps, iconVariants } from './iconVariants';

export function ValueIcon({ size, className, strokeWidth = 0 }: IconProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.52 63.98"
      className={iconVariants({ size, className })}
    >
      <g>
        <g>
          <path
            strokeWidth={strokeWidth}
            stroke="currentColor"
            fill="currentColor"
            d="M59.26,19.18c-.42-.95-1.53-1.39-2.48-.97-.95.42-1.39,1.52-.97,2.48,2.83,6.49,3.25,13.5,2.76,17.53-.3,2.47-.63,4.51-1.23,6.48-2.09,6.76-7.96,12.38-14.96,14.33-5.58,1.56-11.95,1.59-18.43.1-12.92-2.98-16.38-9.17-17.69-11.5l-.21-.37c-3.79-6.58-1.91-19.01-1.24-21.05,1.45-4.41,3.63-9.97,7.61-13.97,4.35-4.37,11.59-7.09,17.99-6.78,2.86.14,5.88.35,8.61.95,1.01.22,2.02-.42,2.24-1.44.22-1.02-.43-2.02-1.44-2.24-3-.65-6.2-.88-9.22-1.03-7.41-.38-15.79,2.8-20.85,7.88C5.23,14.15,2.83,20.24,1.24,25.03c-.91,2.77-2.91,16.34,1.55,24.1l.19.33c1.53,2.73,5.58,9.98,20.13,13.33,3.44.79,6.87,1.19,10.19,1.19,3.51,0,6.91-.44,10.09-1.33,8.19-2.28,15.08-8.89,17.54-16.84.73-2.36,1.09-4.82,1.37-7.13.58-4.72.08-12.32-3.05-19.49Z"
          />
          <path
            strokeWidth={strokeWidth}
            stroke="currentColor"
            fill="currentColor"
            d="M14.15,37.09c.07.99.89,1.76,1.88,1.76.04,0,.09,0,.13,0l4.32-.29c1.38,4.53,4.64,8.26,8.7,9.82,2.19.84,4.5,1.04,6.37,1.04.58,0,1.11-.02,1.59-.04,1.04-.05,1.84-.93,1.79-1.97-.05-1.04-.95-1.82-1.97-1.79-2.71.13-4.76-.11-6.43-.75-2.75-1.06-5.03-3.51-6.19-6.57l8.5-.58c1.04-.07,1.82-.97,1.75-2-.07-1.04-.96-1.83-2-1.75l-9.06.61c-.09-1.15-.06-2.34.1-3.56,2.99-.17,5.97-.24,8.91-.31,1.04-.02,1.86-.89,1.84-1.92-.02-1.02-.86-1.84-1.88-1.84-.01,0-.03,0-.04,0-2.62.06-5.27.13-7.94.26.17-.49.35-.99.56-1.48.98-2.34,2.13-4,3.54-5.08,1.88-1.45,4.41-2.1,7.98-2.03,1.04-.02,1.9-.81,1.92-1.85s-.81-1.9-1.85-1.92c-4.48-.06-7.76.81-10.35,2.81-1.93,1.49-3.48,3.65-4.71,6.61-.44,1.05-.8,2.12-1.08,3.19-1.89.15-3.78.35-5.67.63-1.03.15-1.74,1.11-1.58,2.14.14.93.94,1.6,1.86,1.6.09,0,.19,0,.28-.02,1.46-.22,2.93-.39,4.41-.52-.11,1.2-.12,2.38-.03,3.53l-3.87.26c-1.04.07-1.82.97-1.75,2Z"
          />
          <path
            strokeWidth={strokeWidth}
            stroke="currentColor"
            fill="currentColor"
            d="M41.36,8.09c-1.04-.04-1.91.78-1.94,1.82-.03,1.04.78,1.91,1.82,1.94l7.15.24c-.05,2.21-.12,4.5-.23,7.09-.04,1.04.76,1.92,1.8,1.96.03,0,.05,0,.08,0,1,0,1.84-.79,1.88-1.8.11-2.6.18-4.9.23-7.12l6.56.22s.04,0,.06,0c1.01,0,1.85-.8,1.88-1.82.03-1.04-.78-1.91-1.82-1.94l-6.63-.22c.01-2.12,0-4.26-.04-6.6-.02-1.03-.86-1.85-1.88-1.85h-.03c-1.04.02-1.87.87-1.85,1.91.04,2.27.05,4.35.04,6.41l-7.07-.24Z"
          />
        </g>
      </g>
    </svg>
  );
}
